import React, { useContext } from 'react';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
import { CSSObject } from '@core-ui/react-stitch';

type SizeContainerProps = {
  children: JSX.Element
};


const SizeContainer = ({ children }: SizeContainerProps) => {
  const { smallerThan } = useContext(BreakpointContext);
  const isMobile = smallerThan(XLARGE);
  const sizeFacetStyle = (): CSSObject => ({
    boxSizing: 'border-box',
    padding: isMobile ? '0 1rem' : '0',
    width: '100%',
  });

  return (
    <div css={sizeFacetStyle}>
      {children}
    </div>
  );
};

export default SizeContainer;
